export default "__VITE_ASSET__5134d74a__"